<template>
  <span class="question">
    <el-tooltip effect="dark" :placement="placement">
      <!-- 現状は開発者が書いた固定文言のみだが、汎用コンポーネントのため必ずサニタイズを通す -->
      <div slot="content" v-html="sanitizeHtml(content)"></div>
      <i class="el-icon-question"></i>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: 'Question',
  props: {
    placement: String,
    content: String
  }
}
</script>

<style lang="scss" scoped>
.el-tooltip {
  max-width: 300px;
  cursor: help;
  margin: 0 5px;
}
</style>